import { useState } from 'react';
import useMediaQuery from './useMediaQuery';
function useReducedMotion() {
    var _a = useState(false), matches = _a[0], setMatch = _a[1];
    useMediaQuery('(prefers-reduced-motion: reduce)', function (match) {
        setMatch(match);
    });
    return matches;
}
export { useReducedMotion };
export default useReducedMotion;
//# sourceMappingURL=useReducedMotion.js.map